import React, { useState, useEffect } from 'react';
import './PolicyModal.css';

const PolicyModal = ({ slug, title, onClose }) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPolicy = async () => {
            try {
                setLoading(true);
                const baseUrl = process.env.REACT_APP_API_URL || 'https://prox.mycartly.in/api';
                const response = await fetch(`${baseUrl}/landing/policies/${slug}`);
                const result = await response.json();
                if (result.success) {
                    setContent(result.data.description);
                }
            } catch (error) {
                console.error('Error fetching policy:', error);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchPolicy();
        }
    }, [slug]);

    if (!slug) return null;

    return (
        <div className="policy-modal-overlay" onClick={onClose}>
            <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
                <div className="policy-modal-header">
                    <h2>{title}</h2>
                    <button className="policy-modal-close" onClick={onClose}>&times;</button>
                </div>
                <div className="policy-modal-content">
                    {loading ? (
                        <div className="policy-modal-loading">
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PolicyModal;
